var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 16H16V256H256V16Z",
    fill: "#2980B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 136L136 211L116 136L136 61L156 136ZM136 156L211 136L136 116L61 136",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136 178.5C159.472 178.5 178.5 159.472 178.5 136C178.5 112.528 159.472 93.5 136 93.5C112.528 93.5 93.5 112.528 93.5 136C93.5 159.472 112.528 178.5 136 178.5Z",
    fill: "#346DA6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136 173.5C156.711 173.5 173.5 156.711 173.5 136C173.5 115.289 156.711 98.5 136 98.5C115.289 98.5 98.5 115.289 98.5 136C98.5 156.711 115.289 173.5 136 173.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/TW.9569f69e5e3ecf939ef577e8d43cf6d2.svg";
export { ForwardRef as ReactComponent };